/**
 * Agentic Boundary Kernel demo navigation registry.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { defineMonographNavigation } from "@csk/demo-ui/components/monograph-demo-shell";
import { DEMO_COLOR } from "@csk/demo-ui/design-system";
import { OverviewPanel } from "../panels/OverviewPanel.js";
import { SeamCrossingRushPanel } from "../panels/SeamCrossingRushPanel.js";
import { SeamRegimesPanel } from "../panels/SeamRegimesPanel.js";
import { WitnessSuitePanel } from "../panels/WitnessSuitePanel.js";
import { WitnessTupleLabPanel } from "../panels/WitnessTupleLabPanel.js";
import { WitnessDashPanel } from "../panels/WitnessDashPanel.js";
import { ReachabilityLabPanel } from "../panels/ReachabilityLabPanel.js";
import { MechanizationPanel } from "../panels/MechanizationPanel.js";

export const NAV = [
  {
    id: "overview",
    label: "The Thesis",
    subtitle: "Every agent boundary crossing is a CSK seam crossing",
    icon: "◇",
    accent: DEMO_COLOR.success,
    component: OverviewPanel,
  },
  {
    id: "crossing-rush",
    label: "Seam Crossing Rush",
    subtitle: "Play · Assemble each crossing's witness tuple before the seam",
    icon: "⇥",
    accent: DEMO_COLOR.gold,
    component: SeamCrossingRushPanel,
  },
  {
    id: "seam-regimes",
    label: "Seam Regimes (R1–R4)",
    subtitle: "Tool · Sub-agent · External · Persistent",
    icon: "⊞",
    accent: DEMO_COLOR.sky,
    component: SeamRegimesPanel,
  },
  {
    id: "witness-suite",
    label: "Bridge Witness Suite",
    subtitle: "Eight canonical witness types · one per obligation",
    icon: "Σ",
    accent: DEMO_COLOR.violet,
    component: WitnessSuitePanel,
  },
  {
    id: "witness-lab",
    label: "Witness Tuple Lab",
    subtitle: "Hold witnesses · watch a crossing become (un)constructable",
    icon: "▤",
    accent: DEMO_COLOR.gold,
    component: WitnessTupleLabPanel,
  },
  {
    id: "witness-dash",
    label: "Witness Dash",
    subtitle: "Arcade boundary crossings · complete tuples",
    icon: "W",
    accent: DEMO_COLOR.gold,
    component: WitnessDashPanel,
  },
  {
    id: "reachability-lab",
    label: "Reachability Slice Lab",
    subtitle: "DATA.REACH · forward ∩ backward · minimal slice",
    icon: "⇉",
    accent: DEMO_COLOR.cyan,
    component: ReachabilityLabPanel,
  },
  {
    id: "mechanization",
    label: "Mechanization",
    subtitle: "ABK-1..6 · Agda anchors · honest open status",
    icon: "λ",
    accent: DEMO_COLOR.teal,
    component: MechanizationPanel,
  },
] as const;

export const NAVIGATION = defineMonographNavigation(NAV, {
  defaultPanelId: "overview",
});
